import React, { Fragment, useEffect, useRef, useState } from "react";
import { CreditCard } from "lucide-react";
import CircleSpinnerLoader from "../../Reusable/LoaderComponent/CircleSpinnerLoader";
import { Dialog, Transition } from "@headlessui/react";
import NumberInput from "../../Inputs/NumberInput";
import useFormValidations from "@/app/hooks/useFormValidations";
import { useForm } from "react-hook-form";

interface CollectPaymentButtonProps {
  onClick?: (e: any) => void;
  disabled?: boolean;
  amount?: any;
  loading?: boolean;
  mobile?:any;
  className?: string;
  enterAmlount?:any;
  customerMobile?: string;
  setCustomerMobile?: (e: any) => void;
}

const CollectPaymentButton: React.FC<CollectPaymentButtonProps> = ({
  onClick,
  disabled = false,
  amount,
  loading = false,
  mobile,
  className = "",
  customerMobile,
  enterAmlount,
  setCustomerMobile,
}) => {
  


  return (
    <div className="">
      <button
        type="button"
          className={` cursor-pointer px-5 py-2 ${mobile?.length<10||amount<enterAmlount||parseFloat(enterAmlount)===0?"bg-gray-400":"bg-black"}  text-white rounded-lg border-transparent text-sm`}
                      disabled={disabled || loading||mobile?.length<10||amount<enterAmlount||parseFloat(enterAmlount)===0}
                      onClick={(e) => onClick(e)}
       
      
      >
        
        {loading ? <CircleSpinnerLoader h="20" w="100" /> : "Collect Payment"}
      </button>
     
    </div>
  );
};

export default CollectPaymentButton;
